<template>
    <Head>
        <title>Descargas - Iniciar sesión</title>
        <meta head-key="description" name="description" content="Tecnosinergia - Formulario Inicio de sesión Descargas">
        <meta head-key="keywords" name="keywords" content="Descargas, inicio de sesión">
        <meta name="csrf-token" :content="this.$page.props.csrf_token">
    </Head>

    <AuthShell
        title="Iniciar sesión"
        subtitle="Ingresa con tu correo corporativo para administrar descargas."
        brand-title="Descargas"
        brand-subtitle="Administra archivos, firmwares y recursos de marca desde un solo acceso interno."
    >
        <template #icon>
            <LockClosedIcon class="w-7 h-7 text-white" />
        </template>

        <form class="space-y-5" @submit.prevent="submit">
            <div class="group">
                <label for="email" class="ts-label-auth group-hover:text-orange-400">
                    Correo electrónico
                </label>
                <div class="relative">
                    <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                        <UserIcon class="w-5 h-5 text-slate-500 group-focus-within:text-orange-400 transition-colors" />
                    </div>
                    <input
                        type="text"
                        id="email"
                        v-model="form.email"
                        required
                        autofocus
                        autocomplete="email"
                        class="ts-input-auth"
                        placeholder="name@tecnosinergia.com"
                    />
                </div>
            </div>

            <div class="group">
                <label for="password" class="ts-label-auth group-hover:text-orange-400">
                    Contraseña
                </label>
                <div class="relative">
                    <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                        <LockClosedIcon class="w-5 h-5 text-slate-500 group-focus-within:text-orange-400 transition-colors" />
                    </div>
                    <input
                        type="password"
                        id="password"
                        v-model="form.password"
                        autocomplete="current-password"
                        required
                        class="ts-input-auth"
                        placeholder="••••••••"
                    />
                </div>
            </div>

            <button type="submit" class="ts-btn-primary w-full h-14 text-base relative overflow-hidden group">
                <span class="relative z-10">Iniciar sesión</span>
                <span class="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:animate-shine"></span>
            </button>
        </form>
    </AuthShell>
</template>

<script>
import { LockClosedIcon, UserIcon } from '@heroicons/vue/solid';
import { Link, Head } from '@inertiajs/inertia-vue3';
import AuthShell from '@/Components/AuthShell.vue';
import Swal from 'sweetalert2';

export default {
    components: {
        AuthShell,
        LockClosedIcon,
        UserIcon,
        Head,
        Link,
    },
    props: {
        status: String,
    },
    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.route('login'), {
                onFinish: () => this.form.reset('password'),
            });
        },
        message(icon, text) {
            Swal.fire({
                position: 'center',
                icon: icon,
                title: text,
                showConfirmButton: false,
                timer: 1500,
            });
        },
    },
};
</script>
